import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { Stack } from '@mui/material';
import { ConnectorInfo } from 'types/types';
import { DescriptionText } from './ConnectorDescriptionText';
import { ConnectHelpTemplate } from './ConnectorHelpTemplate';

const useStyles = makeStyles((theme) => ({
  stack: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    padding: theme.spacing(0, 2)
  }
}));

type ConnectorDescriptionProps = {
  info: ConnectorInfo;
};

export const ConnectorDescriptionTemplate: React.FC<ConnectorDescriptionProps> = ({
  info
}: ConnectorDescriptionProps) => {
  const classes = useStyles();
  return (
    <Stack className={classes.stack} data-testid="all-components">
      <DescriptionText info={info} />
      <ConnectHelpTemplate info={info} />
    </Stack>
  );
};
